/* eslint-disable @typescript-eslint/no-explicit-any */
type RC = {
  NEXT_PUBLIC_ORG?: string;
  NEXT_PUBLIC_BASE_API?: string;
  NEXT_PUBLIC_BASE_PATH?: string;
  NEXT_PUBLIC_PAYBILL_NUMBER?: string;

  NEXT_PUBLIC_BANK_NAME?: string;
  NEXT_PUBLIC_BANK_ACCOUNT_NAME?: string;
  NEXT_PUBLIC_BANK_ACCOUNT_NUMBER?: string;
};

const win = typeof window !== 'undefined' ? (window as any) : undefined;
const rc: RC | undefined = win?.__RUNTIME_CONFIG__;

export const RUNTIME = {
  ORG: rc?.NEXT_PUBLIC_ORG ?? process.env.NEXT_PUBLIC_ORG,
  BASE_API: rc?.NEXT_PUBLIC_BASE_API ?? process.env.NEXT_PUBLIC_BASE_API,
  BASE_PATH: rc?.NEXT_PUBLIC_BASE_PATH ?? process.env.NEXT_PUBLIC_BASE_PATH,

  PAYBILL:
    rc?.NEXT_PUBLIC_PAYBILL_NUMBER ?? process.env.NEXT_PUBLIC_PAYBILL_NUMBER,

  BANK_NAME: rc?.NEXT_PUBLIC_BANK_NAME ?? process.env.NEXT_PUBLIC_BANK_NAME,

  BANK_ACCOUNT_NAME:
    rc?.NEXT_PUBLIC_BANK_ACCOUNT_NAME ??
    process.env.NEXT_PUBLIC_BANK_ACCOUNT_NAME,
   
  BANK_ACCOUNT_NUMBER:
    rc?.NEXT_PUBLIC_BANK_ACCOUNT_NUMBER ??
    process.env.NEXT_PUBLIC_BANK_ACCOUNT_NUMBER,
};
